import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@ps-gui/shared-core';
import { Ct2Config } from '@ps-gui/claims-terminal-shared';

@Injectable({
  providedIn: 'root',
})
export class Ct2ConfigService {
  private readonly baseConfigService: ConfigService<Ct2Config> = inject(ConfigService);

  get config() {
    return this.baseConfigService.config;
  }
}
